import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import {
  DETAILS_CACHE_TIME,
  DETAILS_REFETCH_INVERVAL,
  DETAILS_STALE_TIME,
  getUserDetails,
} from "@api/consumer";
import { useQuery } from "@tanstack/react-query";
import Benefits from "./Benefits";
import HowToRecommend from "./HowToRecommend";
import { EasterEgg } from "@pages/EasterEggPage";

export default function Recommend() {
  const navigate = useNavigate();
  const location = useLocation();
  const [content, setContent] = useState();

  const { data } = useQuery({
    queryKey: ["user-details"],
    queryFn: () => getUserDetails(),
    enabled: !!localStorage.getItem("token"),
    refetchInterval: DETAILS_REFETCH_INVERVAL,
    staleTime: DETAILS_STALE_TIME,
    cacheTime: DETAILS_CACHE_TIME,
  });

  const redirectTo = () => {
    const userBrands = data?.consumer?.brands;
    if (location.pathname === "/invite") {
      navigate("/invite/vuse");

      // if (userBrands.includes("vuse")) {
      //   navigate("/invite/vuse");
      // }
      //  else if (userBrands.includes("glo")) {
      //   navigate(`/invite/glo`);
      // }
    }
  };

  useEffect(() => {
    redirectTo();
    setContent(location.pathname);
  }, [location.pathname, data]);

  return (
    <section className="recommend-page">
      <PagesHeader>
        <strong>Freunde </strong>einladen
      </PagesHeader>
      {/* {data?.consumer?.brands.length === 2 && (
        <div className="tab-navigation">
          <div
            className={`tab-navigation-left ${
              content === "/invite/vuse" ? "active" : ""
            }`}
            onClick={() => navigate("/invite/vuse")}
          >
            Vuse
          </div>
          <div
            className={`tab-navigation-right ${
              content === "/invite/glo" ? "active" : ""
            }`}
            onClick={() => navigate("/invite/glo")}
          >
            glo™
          </div>
        </div>
      )} */}
      <div className="recommend-page-content">
        <Outlet />
        <Benefits content={content} />
        {/* <EasterEgg ident={"halloween2025_3"} direction="right" /> */}
        <HowToRecommend content={content} />
      </div>
    </section>
  );
}
